import React from 'react';
import {theme} from '../theme/theme';
import {Box} from '../box';
import {FrameworkImage} from '../image-renderer';
import {Typography} from '../typography';
import {Pressable} from '../pressable';

export interface CoverImageProps {
  image?: string;
  logo?: string;
  artistName?: string | null;
  isStudioPage?: boolean;
  onBack?: () => void;
}

export const CoverImage: React.FC<CoverImageProps> = ({
  image,
  logo,
  artistName,
  isStudioPage,
  onBack,
}: CoverImageProps) => {
  let fillColor = '#FF6C74';
  if (artistName?.includes('The Drop')) {
    fillColor = '#476E55';
  }
  if (artistName?.includes('Here At Last')) {
    fillColor = '#039BE5';
  }

  if (artistName?.includes('Goodwood')) {
    fillColor = '#FFFFFF';
  }


  return (
    <Box
      alignItems="flex-start"
      backgroundRepeat="no-repeat"
      backgroundPosition="center"
      width="100%"
      height={['390px', '384px', '480px', '600px']}
      padding={['md', 'lg']}
      css={{
        backgroundImage: `url(${image})`,
        backgroundSize: isStudioPage ? 'auto' : 'cover',
      }}
    >
      <Box
        position="absolute"
        top="50%"
        left="0"
        right="0"
        bottom="0"
        css={{
          background: isStudioPage
            ? theme.colors.gradientBottom
            : theme.colors.gradientPrimary,
          transform: 'rotate(-180deg)' as any,
        }}
      />
      <Box
        position="absolute"
        top="0"
        left="0"
        right="0"
        bottom="50%"
        css={{
          background: theme.colors.gradientTop,
        }}
      />
      <div style={{display: 'flex', alignItems: 'center', width: '100%'}}>
        {isStudioPage && (
          <Pressable onPress={onBack}>
            <div style={{transform: 'rotate(180deg)', height: '36px'}}>
              <svg
                width={36}
                height={36}
                viewBox="0 0 10 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.65102 7.85707L9.50102 4.00707L5.65102 0.143066H4.12502L7.42902 3.43307H0.499023V4.58107H7.42902L4.12502 7.85707H5.65102Z"
                  fill={`${fillColor} !important`}
                  style={{
                    fill: `${fillColor} !important`,
                  }}
                />
              </svg>
            </div>
          </Pressable>
        )}
        &nbsp;&nbsp;&nbsp;
        {logo ? (
          <Box height={['30px', '40px', '50px', '60px']} width="100%">
            <FrameworkImage
              src={logo}
              alt="artist logo"
              layout="fill"
              objectFit="contain"
              objectPosition="left"
            />
          </Box>
        ) : null}
        {!logo && artistName ? (
          <Typography
            textStyle={['h2', 'h1']}
            color="textDefault"
            style={{zIndex: 1}}
          >
            {artistName}
          </Typography>
        ) : null}
      </div>
    </Box>
  );
};
